module.exports = "<p>\r\n  reports works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_Components/reports/reports.component.html
// module id = 413
// module chunks = 1